/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ChangeBadge from '../changebadge/changebadge';
// styles
import injectSheet from 'react-jss';
import styles from './chartlegend_styles';


/* ========== ~~~~~~~~~~ CHART LEGEND ~~~~~~~~~~ ========== */
const ChartLegend = injectSheet(styles)((props) => {
    const {
        title,
        value,
        changeDirection,
        change,
        changeType,
        metricType,
        checked,
        onCheck,
        handleLegendClick,
        isLegendClickable,
        handleOnMouseEnter,
        handleOnMouseLeave,
        isGrayedOut
    } = props;

    const handleCheck = () => onCheck ? onCheck(!checked) : false;

    const showMonetizationRateChange = (metricType === 'monetization' && changeType && changeType.toLowerCase() !== 'pop');

    const showProductAnalyticsRateChange = (metricType === 'commenting' || metricType === 'trivia');

    return (
        <div className={`chartlegend ${props.classes.chartlegend}`} >
           <div className={'container'}>
               <div className={`checkbox charttoggle`} onClick={handleCheck}></div>
               <div className={`details clickable-${isLegendClickable} grayed-${isGrayedOut}`}
                    onClick={isLegendClickable ? handleLegendClick : undefined}
                    onMouseEnter={(isLegendClickable && handleOnMouseEnter) ? handleOnMouseEnter : undefined}
                    onMouseLeave={(isLegendClickable && handleOnMouseLeave) ? handleOnMouseLeave : undefined}
               >
                    <span className={'title'} title={title}>{title}</span>
                    <div className={'valuebadge'}>
                        <span className={'value'}>{value}</span>
                        { showMonetizationRateChange || showProductAnalyticsRateChange ?
                            <div className={'badgechange'}>
                                <ChangeBadge direction={changeDirection} change={change}/>
                                <span className={'changetype'}>{props.changeType}</span>
                            </div>
                            : ''
                        }
                    </div>
                </div>
           </div>
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ChartLegend;
